import React, {useEffect, useState} from "react";
import {useFormik} from "formik";
import closeIcon from "../../img/closeIcon.svg";
// import showMoreBtnIcon from "../../img/moreButtonTable.svg";
import addPlusIcon from "../../img/addPlusBlueIcon.svg";
import minusIcon from "../../img/iconMinus.svg";
import deleteIcon from "../../img/deleteIcon.svg";
import useAuth from "../../utils/CustomHooks/useAuth/useAuth";
import CustomSelect from "../../utils/CustomSelect/CustomSelect";
import * as Yup from "yup";
import NoOptionsAddButton from "../ReusedComponents/NoOptionsAddButton/NoOptionsAddButton";
import NoOptionsAddElementDictionaryModal
    from "../ReusedComponents/NoOptionsAddElementDictionaryModal/NoOptionsAddElementDictionaryModal";
import {axiosPostAddNewElementDictionary} from "../../Api/ApiDictionary/axiosPostAddNewElementDictionary";
import useAxiosPrivate from "../../utils/CustomHooks/useAxiosPrivate/useAxiosPrivate";
import {
    selectApiPostRequestDictionary
} from "../../utils/SelectApiPostRequestDictionary/selectApiPostRequestDictionary";
import {selectApiBodyRequestDictionary} from "../../utils/SelectApiBodyRequestDictionary/selectApiBodyRequestDictionary";
import {
    findEditDocOptionValue
} from "../../utils/FindValueEditLoadingOrder/FindValueEditLoadingOrder";
import {
    onGetValueOptionsEditDoc
} from "../../utils/OnGetValueOptionsEditDocLoadingOrder/OnGetValueOptionsEditDocLoadingOrder";
// import UploadTemplateDocument from "../UploadTemplateDocument/UploadTemplateDocument";
import useGetListTemplate from "../../utils/CustomHooks/useGetListTemplate/useGetListTemplate";
import NoOptionsClearValue from "../ReusedComponents/NoOptionsClearValue/NoOptionsClearValue";
import NoOptionsEditButton from "../ReusedComponents/NoOptionsEditButton/NoOptionsEditButton";
import NoOptionsEditElementDictionary
    from "../ReusedComponents/NoOptionsEditElementDictionary/NoOptionsEditElementDictionary";
import {useAxiosPutDictionary} from "../../Api/ApiDictionary/axiosPutDictionary";
import NumberRouteOrder from "./NumberRouteOrder/NumberRouteOrder";
import DateRouteOrder from "./DateRouteOrder/DateRouteOrder";
import CargoDeclarationRouteOrder from "./CargoDeclarationRouteOrder/CargoDeclarationRouteOrder";
import RoutingInstructionRouteOrder from "./RoutingInstructionRouteOrder/RoutingInstructionRouteOrder";
import GrossWeightRouteOrder from "./GrossWeightRouteOrder/GrossWeightRouteOrder";

const CreateDocSetLoadingOrderModal = (props) => {

    const {
        closeModal,
        addLoadingOrderCargoCase,
        editDoc,
        cargoCaseDocument,
    } = props;

    const {
            auth,
            dictionaryCountries,
            dictionaryPorts,
            dictionaryVessels,
            dictionaryOrg,
            dictionaryCaptains,
            dictionaryConsignee,
            updateRequestDataDictionary } = useAuth();
    const axiosPrivate = useAxiosPrivate();
    const [isNoOptionMessageValue, setNoOptionMessageValue] = useState('');
    const [isNoOptionMessageEditValue, setNoOptionMessageEditValue] = useState('');
    const [activeModalAddNewElementDictionary, setActiveModalAddNewElementDictionary] = useState(false);
    const [isModalMessage, setModalMessage] = useState('');
    const { isOptionsTemplate} = useGetListTemplate(auth?.user?.organization, 'CARGO_CASE');
    const [itemsRouteOrder, setItemsRouteOrder] = useState([]);
    const [isActiveConsigneeMode, setActiveConsigneeMode] = useState(true);

    const editVessel = useAxiosPutDictionary(axiosPrivate, "vessel");

    const noOptionMessageValue = ['port', 'vessel', 'shipper', 'shipowner'];

    const optionOrgShipper = dictionaryOrg.filter(el => el.isShipowner === false).map(el => ({
        "value": el?.id,
        "label": el?.name
    }))

    const optionOrgShipOwner = dictionaryOrg.filter(el => el.isShipowner === true).map(el => ({
        "value": el?.id,
        "label": el?.name
    }))

    const optionPorts = dictionaryPorts.map(el => ({
        "value": el?.id,
        "label": el?.name
    }))

    const optionVessels = dictionaryVessels.map(el => ({
        "value": el?.id,
        "label": el?.name,
        "country": el?.country
    }))

    const optionDestinationCountry = dictionaryCountries.map(el => ({
        "value": el?.id,
        "label": el?.name
    }))

    const optionsCaptain = dictionaryCaptains.filter(el => el?.roles[0] === 'CAPTAIN').map(el => ({
        "value": el?.id,
        "label": el?.lastName + " " + el?.firstName
    }))

    const optionsTemplate = isOptionsTemplate.map(el => ({
        "value": el?.id,
        "label": el?.fileName
    }))

    const optionsConsignee = dictionaryConsignee.map((el, i) => ({
        "value": i,
        "label": el
    }))

    function idGenerate(arr) {
        if (arr.length < 1) {
            return 1;
        } else {
            const allIdArray = arr.map((arr) => {
                return arr.id;
            });
            return Math.max(...allIdArray) + 1;
        }
    }
    
    function onCloseModal() {
        setNoOptionMessageValue('');
        setActiveModalAddNewElementDictionary(false);
        setModalMessage('');
        setNoOptionMessageEditValue('');
    }

    const onHandleAddElementDictionaryModal = (value) => {
        setNoOptionMessageValue(value);
        setActiveModalAddNewElementDictionary(true);
    }

    const onHandleEditElementDictionaryModal = (value) => {
        setNoOptionMessageEditValue(value);
    }

    const onHandleClearValue = (typeField) => {
        formik.setFieldValue(typeField, '')
    }

    const addRouteOrder = () => {
        const itemOrder = {
            id: idGenerate(itemsRouteOrder),
            number: "",
            date: "",
            unitsType: "KGS",
            goods: [
                    {
                        exportVGTD: "",
                        importVGTD: "",
                        grossWeight: 0,
                    }
                ]
            }
        setItemsRouteOrder([...itemsRouteOrder, itemOrder])
    }

    const addStringRouteOrder = (orderId) => {
        const itemGoods = {
            exportVGTD: "",
            importVGTD: "",
            grossWeight: 0,
        }
        const filteredNumberOrders = itemsRouteOrder.find((value) => value.id === orderId);
        const changedOrder = {...filteredNumberOrders, goods: [...filteredNumberOrders.goods, itemGoods]}
        const updatedRouteOrder = itemsRouteOrder.map((el) => el.id === orderId ? changedOrder : el)
            setItemsRouteOrder(updatedRouteOrder)
    }

    function removeRouteOrder(id) {
        const filteredAnswers = itemsRouteOrder.filter((value) => value.id !== id);
        setItemsRouteOrder(filteredAnswers);
    }

    function removeStringRouteOrder(orderId, indexRouteOrder) {
        const filteredNumberOrders = itemsRouteOrder.find((value) => value.id === orderId);
        const filteredRouteOrders = filteredNumberOrders.goods.filter((value, index) => index !== indexRouteOrder);
        const changedOrder = {...filteredNumberOrders, goods: filteredRouteOrders}
        const updatedRouteOrder = itemsRouteOrder.map((el) => el.id === orderId ? changedOrder : el)
            setItemsRouteOrder(updatedRouteOrder)
    }

    const noOptionsMessageCreateElement = (value) => {
        return (
            <>
                <NoOptionsAddButton
                    onHandleOpenAddNewValueModal={() => onHandleAddElementDictionaryModal(value)}
                />
                {value === 'vessel' &&
                    <NoOptionsEditButton
                        onHandleOpenAddNewValueModal={() => onHandleEditElementDictionaryModal(value)}
                    />
                }
            </>
        )
    }

    const onClearTemplate = (typeField) => {
        return (
            <NoOptionsClearValue
                onHandleClearValue={() => onHandleClearValue(typeField)}
            />
        )
    }

    function onHandleConfirmAddElementDictionary (isNoOptionMessageValue, isNameElement, isAddressElement, isSelectedItemDictionary, isActiveCheckBox) {
        if (isNoOptionMessageValue === 'vessel' && isActiveCheckBox === false && isNameElement === '') {
            setModalMessage('All fields must be filled!');
        } else if (isNoOptionMessageValue === 'vessel' && isActiveCheckBox === true && (isNameElement === '' || isSelectedItemDictionary === null)) {
            setModalMessage('All fields must be filled!');
        } else if (isNoOptionMessageValue === 'port' && (isNameElement === '' || isSelectedItemDictionary === null)) {
            setModalMessage('All fields must be filled!');
        } else if (isNoOptionMessageValue === 'shipper' && isActiveCheckBox === false && isNameElement === '') {
            setModalMessage('All fields must be filled!');
        } else if (isNoOptionMessageValue === 'shipper' && isActiveCheckBox === true && (isNameElement === '' || isAddressElement === '')) {
            setModalMessage('All fields must be filled!');
        } else if (isNoOptionMessageValue === 'shipowner' && isActiveCheckBox === false && isNameElement === '') {
            setModalMessage('All fields must be filled!');
        } else if(isNoOptionMessageValue === 'shipowner' && isActiveCheckBox === true && (isNameElement === '' || isAddressElement === '')) {
            setModalMessage('All fields must be filled!');
        }else {
                axiosPostAddNewElementDictionary(axiosPrivate,
                    selectApiPostRequestDictionary(isNoOptionMessageValue),
                    selectApiBodyRequestDictionary(isNoOptionMessageValue, isNameElement, isAddressElement, isNoOptionMessageValue === 'vessel' && isActiveCheckBox === false ? 0 : isSelectedItemDictionary),
                        updateRequestDataDictionary,
                        setActiveModalAddNewElementDictionary,
                        setModalMessage)
            }
        }

    function onHandleConfirmEditElementDictionary(isNameElement, isSelectedItemDictionary) {
        const body = {
            name: isNameElement?.label,
            country_id: isSelectedItemDictionary
        }
        if (isNameElement.label === undefined || isSelectedItemDictionary === null) {
            setModalMessage('All fields must be filled!');
        } else {
            editVessel(isNameElement.value, body)
                .then(onCloseModal)
                .catch((err) => console.log(err))}
        }

    const formik = useFormik({
        initialValues: {
            number: cargoCaseDocument[0]?.number,
            dateOfCreation: editDoc === true ? cargoCaseDocument[0]?.dateOfCreation : "",
            loadingOrderReceiver: editDoc === true ? cargoCaseDocument[0]?.loadingOrderReceiver : "",
            portOfLoading: editDoc === true ? findEditDocOptionValue(cargoCaseDocument[0]?.portOfLoading?.id, optionPorts) : "",
            portOfDischarge: editDoc === true ? findEditDocOptionValue(cargoCaseDocument[0]?.portOfDischarge?.id, optionPorts) : "",
            shipper: editDoc === true ? findEditDocOptionValue(cargoCaseDocument[0]?.shipper?.id, optionOrgShipper) : "",
            consignee: editDoc === true ? cargoCaseDocument[0]?.consignee : "",
            vessel: editDoc === true ? findEditDocOptionValue(cargoCaseDocument[0]?.vessel?.id, optionVessels) : "",
            shipowner: editDoc === true ? findEditDocOptionValue(cargoCaseDocument[0]?.shipowner?.id, optionOrgShipOwner) : "",
            destination: "destination",
            destinationCountry_id: editDoc === true ? cargoCaseDocument[0]?.destinationCountry?.id : "",
            estimatedTimeArrived: editDoc === true ? cargoCaseDocument[0]?.estimatedTimeArrived : "",
            methodOfCleaningLines: editDoc === true ? cargoCaseDocument[0]?.methodOfCleaningLines : "",
            captain_id: editDoc === true ? cargoCaseDocument[0]?.captain?.id : "",
            numberCertOfOrigin: editDoc === true ? cargoCaseDocument[0]?.numberCertOfOrigin : "",
            loadingWindow: editDoc === true ? cargoCaseDocument[0]?.loadingWindow : "",
            instructionDate: "",
            label: editDoc === true ? cargoCaseDocument[0]?.label : "",
            template_id: editDoc === true && cargoCaseDocument[0]?.template !== undefined ? cargoCaseDocument[0]?.template?.id : '',
            vesselFlag_id: null
        },
        validationSchema: Yup.object({
            number: Yup.string()
                .matches(/(?:\s|^)[\p{L}\p{M}0-9\-._]+(?:\s|$)/u, 'Is not in correct format!')
                .required('Required field!'),
            dateOfCreation: Yup.date()
                .required('Required field!'),
            loadingOrderReceiver: Yup.string()
                .matches(/(?:\s|^)[\p{L}\p{M}0-9\-._]+(?:\s|$)/u, 'Is not in correct format!')
                .required('Required field!'),
            portOfLoading: Yup.object()
                .required('Required field!'),
            portOfDischarge: Yup.object()
                .required('Required field!')
                .test('equal', 'Loading port should not be equal to discharge port', function () {
                    const valuePortOfLoading = formik.values.portOfLoading
                    const valuePortOfDischarge = formik.values.portOfDischarge
                     return (valuePortOfLoading.name !== valuePortOfDischarge.name)
                }),
            shipper: Yup.object()
                .required('Required field!'),
            consignee: Yup.string()
                .matches(/(?:\s|^)[\p{L}\p{M}0-9\-._]+(?:\s|$)/u, 'Is not in correct format!')
                .required('Required field!'),
            vessel: Yup.object()
                .required('Required field!'),
            // shipOwner: Yup.object()
            //     .required('Required field!'),
            // destination: Yup.string()
            //     .matches(/^([а-яё]+|[a-z]+)$/i, 'Is not in correct format!')
            //     .required('Required field!'),
            destinationCountry_id: Yup.number()
                .required('Required field!'),
            estimatedTimeArrived: Yup.date()
                // .min(Yup.ref('dateOfCreation'), "End date can't be before order date")
                .required('Required field!'),
            methodOfCleaningLines: Yup.string()
                .matches(/^([а-яё]+|[a-z]+)$/i, 'Is not in correct format!'),
            // captain_id: Yup.number()
            //     .required('Required field!'),
            numberCertOfOrigin: Yup.string()
                .required('Required field!'),
            loadingWindow: Yup.string()
                // .min(Yup.ref('dateOfCreation'), "End date can't be before order date")
                // .max(Yup.ref('estimatedTimeArrived'), "End date can't be after estimated date")
                .required('Required field!'),
            // instructionDate: Yup.date()
            //     // .min(Yup.ref('dateOfCreation'), "End date can't be before order date")
            //     // .max(Yup.ref('estimatedTimeArrived'), "End date can't be after estimated date")
            //     .required('Required field!'),
            // exportVGTD: Yup.string()
            //     .required('Required field!'),
            // importVGTD: Yup.string()
            //     .required('Required field!'),
            // grossWeight: Yup.string()
            //     .required('Required field!')
            //     .matches(/^\d+$/, 'Is not in correct format!'),
            label: Yup.string()
                .required('Required field!')
        }),
        onSubmit: values => addLoadingOrderCargoCase(values, itemsRouteOrder)
    })

    const selectFlagFromCountry = (id) => {
        if (id) {
            const selectFlag = dictionaryCountries.find(el => el.id === id);
            return selectFlag?.name
        }
    }

    const findFlagVessel = (id) =>  {
        const selectCargoCase = dictionaryVessels.find(el => el.id === id);
        if (selectCargoCase?.country?.id !== undefined) {
            formik.setFieldValue('vesselFlag_id', selectCargoCase?.country?.id)
        } else {
            formik.setFieldValue('vesselFlag_id', 0)
        }
    }

    useEffect(() => {
        findFlagVessel(formik?.values?.vessel?.id)
    },[formik?.values?.vessel, dictionaryVessels])

    return (
        <div className="create-doc-set-loading-order-modal__container">
            <form onSubmit={formik.handleSubmit} className="create-doc-set-loading-order-modal">
                <div className="create-doc-set-loading-order-modal__title">
                    <h3>CargoCase Info</h3>
                    <img onClick={closeModal} src={closeIcon} alt={'иконка крестик'}/>
                </div>
                <div className="create-doc-set-loading-order-modal__three-inputs-item">
                    <label htmlFor="template_id">Select loading order template</label>
                    <CustomSelect
                        options={optionsTemplate}
                        value={formik.values.template_id}
                        onChange={value => formik.setFieldValue('template_id', value.value)}
                        noOptionsMessage={() => onClearTemplate('template_id')}
                    />
                </div>
                <h3 className="create-doc-set-loading-order-modal-commission"></h3>
                <div className="create-doc-set-loading-order-modal__three-inputs">
                    <div className="create-doc-set-loading-order-modal__three-inputs-item">
                        <label>CargoCase name</label>
                        <input className="create-doc-set-loading-order-modal__input-text"
                               type={'text'}
                               name={'number'}
                               defaultValue={cargoCaseDocument[0].number}
                               onChange={formik.handleChange}
                               onBlur={formik.handleBlur}
                               disabled={true}
                        />
                        {formik.errors.number && formik.touched.number ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.number}</p> : null}
                    </div>
                    <div className="create-doc-set-loading-order-modal__three-inputs-item">
                        <label>CargoCase date</label>
                        <input className="create-doc-set-loading-order-modal__input-text"
                               type={"date"}
                               name={'dateOfCreation'}
                               defaultValue={editDoc === true ? cargoCaseDocument[0].dateOfCreation : formik.values.name}
                               onChange={formik.handleChange}
                               onBlur={formik.handleBlur}
                        />
                        {formik.errors.dateOfCreation && formik.touched.dateOfCreation ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.dateOfCreation}</p> : null}
                    </div>
                    <div className="create-doc-set-loading-order-modal__three-inputs-item">
                        <label>Description of goods</label>
                        <input className="create-doc-set-loading-order-modal__input-text"
                               type={'text'}
                               name={'numberCertOfOrigin'}
                               defaultValue={editDoc === true ? cargoCaseDocument[0]?.numberCertOfOrigin : formik.values.name}
                               onChange={formik.handleChange}
                               onBlur={formik.handleBlur}
                        />
                        {formik.errors.numberCertOfOrigin && formik.touched.numberCertOfOrigin ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.numberCertOfOrigin}</p> : null}
                    </div>
                </div>
                <div className="create-doc-set-loading-order-modal__three-inputs">
                    <div className="create-doc-set-loading-order-modal__three-inputs-item">
                        <label>Loading window</label>
                        <input className="create-doc-set-loading-order-modal__input-text"
                               type={'text'}
                               name={'loadingWindow'}
                               defaultValue={editDoc === true ? cargoCaseDocument[0]?.loadingWindow : formik.values.name}
                               onChange={formik.handleChange}
                               onBlur={formik.handleBlur}
                        />
                        {formik.errors.loadingWindow && formik.touched.loadingWindow ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.loadingWindow}</p> : null}
                    </div>
                    <div className="create-doc-set-loading-order-modal__three-inputs-item">
                        <label>Date of arrival</label>
                        <input className="create-doc-set-loading-order-modal__input-text"
                               type={'date'}
                               name={'estimatedTimeArrived'}
                               defaultValue={editDoc === true ? cargoCaseDocument[0]?.estimatedTimeArrived : formik.values.name}
                               onChange={formik.handleChange}
                               onBlur={formik.handleBlur}
                        />
                        {formik.errors.estimatedTimeArrived && formik.touched.estimatedTimeArrived ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.estimatedTimeArrived}</p> : null}
                    </div>
                    <div className="create-doc-set-loading-order-modal__three-inputs-item">
                        <label>Customs declaration Receiver</label>
                        <input className="create-doc-set-loading-order-modal__input-text"
                               type={'text'}
                               name={'loadingOrderReceiver'}
                               defaultValue={editDoc === true ? cargoCaseDocument[0]?.loadingOrderReceiver : formik.values.name}
                               onChange={formik.handleChange}
                               onBlur={formik.handleBlur}
                        />
                        {formik.errors.loadingOrderReceiver && formik.touched.loadingOrderReceiver ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.loadingOrderReceiver}</p> : null}
                    </div>
                </div>
                <div className="create-doc-set-loading-order-modal__three-inputs">
                    <div className="create-doc-set-loading-order-modal__three-inputs-item">
                        <label htmlFor="portOfLoading">Port of loading</label>
                        <CustomSelect
                            options={optionPorts}
                            value={onGetValueOptionsEditDoc(formik.values.portOfLoading)}
                            onChange={value => formik.setFieldValue('portOfLoading', JSON.parse(JSON.stringify(value).replaceAll('"value"', '"id"').replaceAll('"label"', '"name"')))}
                            noOptionsMessage={() =>  noOptionsMessageCreateElement(noOptionMessageValue[0])}
                        />
                        {formik.errors.portOfLoading && formik.touched.portOfLoading ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.portOfLoading}</p> : null}
                    </div>
                    <div className="create-doc-set-loading-order-modal__three-inputs-item">
                        <label htmlFor="portOfDischarge">Port of discharge</label>
                        <CustomSelect
                            options={optionPorts}
                            value={onGetValueOptionsEditDoc(formik.values.portOfDischarge)}
                            onChange={value => formik.setFieldValue('portOfDischarge', JSON.parse(JSON.stringify(value).replaceAll('"value"', '"id"').replaceAll('"label"', '"name"')))}
                            noOptionsMessage={() =>  noOptionsMessageCreateElement(noOptionMessageValue[0])}
                        />
                        {formik.errors.portOfDischarge && formik.touched.portOfDischarge ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.portOfDischarge}</p> : null}
                    </div>
                    <div className="create-doc-set-loading-order-modal__three-inputs-item">
                        <label htmlFor="destinationCountry_id">Destination country</label>
                        <CustomSelect
                            options={optionDestinationCountry}
                            value={formik.values.destinationCountry_id}
                            onChange={value => formik.setFieldValue('destinationCountry_id', value.value)}
                        />
                        {formik.errors.destinationCountry_id && formik.touched.destinationCountry_id ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.destinationCountry_id}</p> : null}
                    </div>
                </div>
                <div className="create-doc-set-loading-order-modal__three-inputs">
                    {/*<div className="create-doc-set-loading-order-modal__three-inputs-item">*/}
                    {/*    <label>Instruction date</label>*/}
                    {/*    <input className="create-doc-set-loading-order-modal__input-text"*/}
                    {/*           type={"date"}*/}
                    {/*           name={'instructionDate'}*/}
                    {/*           defaultValue={editDoc === true ? cargoCaseDocument[0]?.instructionDate : formik.values.name}*/}
                    {/*           onChange={formik.handleChange}*/}
                    {/*           onBlur={formik.handleBlur}*/}
                    {/*    />*/}
                    {/*    {formik.errors.instructionDate && formik.touched.instructionDate ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.instructionDate}</p> : null}*/}
                    {/*</div>*/}
                    <div className="create-doc-set-loading-order-modal__three-inputs-item">
                        <label className="create-doc-set-loading-order-modal__label-select">
                            <p className={isActiveConsigneeMode ? "create-doc-set-loading-order-modal__label-select-item active" : "create-doc-set-loading-order-modal__label-select-item"} 
                                onClick={() => setActiveConsigneeMode(true)}>
                                    Enter consignee</p>/<p className={isActiveConsigneeMode ? "create-doc-set-loading-order-modal__label-select-item" : "create-doc-set-loading-order-modal__label-select-item active"}  onClick={() => setActiveConsigneeMode(false)}>Select from list</p></label>
                        {isActiveConsigneeMode ? (
                            <input className="create-doc-set-loading-order-modal__input-text"
                            type={"text"}
                            name={'consignee'}
                            defaultValue={editDoc === true ? cargoCaseDocument[0]?.consignee : formik.values.consignee}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            />        
                        ) : (
                            <CustomSelect
                            options={optionsConsignee}
                            value={formik.values.consignee}
                            onChange={value => formik.setFieldValue('consignee', JSON.parse(JSON.stringify(value.label).replaceAll('"label"', '"name"')))}
                            /> 
                        )}
                        {formik.errors.consignee && formik.touched.consignee ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.consignee}</p> : null}
                    </div>
                    <div className="create-doc-set-loading-order-modal__three-inputs-item">
                        <label htmlFor="shipper">Shipper</label>
                        <CustomSelect
                            options={optionOrgShipper}
                            value={onGetValueOptionsEditDoc(formik.values.shipper)}
                            onChange={value => formik.setFieldValue('shipper', JSON.parse(JSON.stringify(value).replaceAll('"value"', '"id"').replaceAll('"label"', '"name"')))}
                            noOptionsMessage={() =>  noOptionsMessageCreateElement(noOptionMessageValue[2])}
                        />
                        {formik.errors.shipper && formik.touched.shipper ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.shipper}</p> : null}
                    </div>
                    <div className="create-doc-set-loading-order-modal-add-new-field__new-input">
                        <label>Additional info</label>
                        <div className="create-doc-set-loading-order-modal-add-new-field__new-input-select">
                            <textarea className="create-doc-set-loading-order-modal__input-textarea"
                                   type={'text'}
                                   name={'label'}
                                   defaultValue={editDoc === true ? cargoCaseDocument[0]?.label : formik.values.label}
                                   onChange={formik.handleChange}
                                   onBlur={formik.handleBlur}
                            />
                            {formik.errors.label && formik.touched.label ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.label}</p> : null}
                            {/*<img className="create-doc-set-loading-order-modal-add-new-field__icon-show-more" src={showMoreBtnIcon} alt={'иконка показать больше'}/>*/}
                        </div>
                    </div>
                </div>
                <div className="create-doc-set-loading-order-modal-add-new-field">
                    <div onClick={() => addRouteOrder()} className="create-doc-set-loading-order-modal-add-new-field__btn-add-new">
                        <img src={addPlusIcon} alt={'иконка плюс'} />
                        <p>Add loading orders</p>
                    </div>
                    {itemsRouteOrder.length !== 0 && <div className="create-doc-set-loading-order-modal__table">
                        <div className="create-doc-set-loading-order-modal__table-header">
                            <p>Loading order number</p>
                            <p>Loading order date</p>
                            <p>Routing instruction</p>
                            <p>Cargo declaration</p>
                            <p>Gross weight</p>
                        </div>
                        <>
                        {itemsRouteOrder.map((el) => {
                            return (
                                <div key={el.id} className="create-doc-set-loading-order-modal__table-row">
                                    <NumberRouteOrder
                                        elemId={el.id}
                                        itemsRouteOrder={itemsRouteOrder}
                                        setItemsRouteOrder={setItemsRouteOrder}
                                    />
                                    <DateRouteOrder
                                        elemId={el.id}
                                        itemsRouteOrder={itemsRouteOrder}
                                        setItemsRouteOrder={setItemsRouteOrder}
                                    />
                                        <div className="create-doc-set-loading-order-modal__table-string-instruction">
                                            {el?.goods?.map((item, i) => {
                                                return (
                                                    <div key={i} className="create-doc-set-loading-order-modal__table-string-items">
                                                        <RoutingInstructionRouteOrder
                                                            elemId={el.id}
                                                            itemsRouteOrder={itemsRouteOrder}
                                                            setItemsRouteOrder={setItemsRouteOrder}
                                                            indexItem={i}
                                                        />
                                                        <CargoDeclarationRouteOrder
                                                            elemId={el.id}
                                                            itemsRouteOrder={itemsRouteOrder}
                                                            setItemsRouteOrder={setItemsRouteOrder}
                                                            indexItem={i}
                                                        />
                                                        <GrossWeightRouteOrder
                                                            elemId={el.id}
                                                            itemsRouteOrder={itemsRouteOrder}
                                                            setItemsRouteOrder={setItemsRouteOrder}
                                                            indexItem={i}
                                                        />
                                                        {i !== 0 && <img onClick={() => removeStringRouteOrder(el.id, i)} className="create-doc-set-loading-order-modal__table-row-icon-minus" src={minusIcon} alt={'icon'}/>}            
                                                    </div>
                                            )})} 
                                        </div>
                                    <div className="create-doc-set-loading-order-modal__table-icons-block">
                                        <img onClick={() => addStringRouteOrder(el.id)} className="create-doc-set-loading-order-modal__table-row-icon-plus" src={addPlusIcon} alt={'icon'}/>           
                                        <img onClick={() => removeRouteOrder(el.id)} className="create-doc-set-loading-order-modal__table-row-icon" src={deleteIcon} alt={'icon'}/>
                                    </div>
                                </div>
                            )})}
                        </>
                    </div>}
                </div>
                <div className="create-doc-set-loading-order-modal-cargo-documents">
                    <h3 className="create-doc-set-loading-order-modal-cargo-documents__title">
                        Cargo documents
                    </h3>
                    <div className="create-doc-set-loading-order-modal__three-inputs">
                        <div className="create-doc-set-loading-order-modal__three-inputs-item">
                            <label htmlFor="vessel">Vessel</label>
                            <CustomSelect
                                options={optionVessels}
                                value={onGetValueOptionsEditDoc(formik?.values?.vessel)}
                                onChange={value => formik.setFieldValue('vessel', JSON.parse(JSON.stringify(value).replaceAll('"value"', '"id"').replaceAll('"label"', '"name"')))}
                                noOptionsMessage={() =>  noOptionsMessageCreateElement(noOptionMessageValue[1])}
                            />
                            {formik.errors.vessel && formik.touched.vessel ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.vessel}</p> : null}
                        </div>
                        <div className="create-doc-set-loading-order-modal__three-inputs-item">
                            <label>Flag</label>
                            <input className="create-doc-set-loading-order-modal__input-text"
                                   type={"text"}
                                   name={'vesselFlag_id'}
                                   defaultValue={selectFlagFromCountry(formik?.values?.vesselFlag_id)}
                                   onChange={formik.handleChange}
                                   disabled={true}
                            />
                        </div>
                        <div className="create-doc-set-loading-order-modal__three-inputs-item">
                            <label htmlFor="captain_id">Capitan</label>
                            <CustomSelect
                                options={optionsCaptain}
                                value={formik.values.captain_id}
                                onChange={value => formik.setFieldValue('captain_id', value.value)}
                                noOptionsMessage={() => onClearTemplate('captain_id', formik.values.captain_id)}
                            />
                            {formik.errors.captain_id && formik.touched.captain_id ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.captain_id}</p> : null}
                        </div>
                    </div>
                    <div className="create-doc-set-loading-order-modal__three-inputs">
                        <div className="create-doc-set-loading-order-modal__three-inputs-item">
                            <label htmlFor="shipowner_id">Shipowner</label>
                            <CustomSelect
                                options={optionOrgShipOwner}
                                value={onGetValueOptionsEditDoc(formik.values.shipowner)}
                                onChange={value => formik.setFieldValue('shipowner', JSON.parse(JSON.stringify(value).replaceAll('"value"', '"id"').replaceAll('"label"', '"name"')))}
                                noOptionsMessage={() =>  noOptionsMessageCreateElement(noOptionMessageValue[3])}
                            />
                            {formik.errors.shipowner && formik.touched.shipowner ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.shipowner}</p> : null}
                        </div>
                        <div className="create-doc-set-loading-order-modal__three-inputs-item create-doc-set-loading-order-modal__input-text-visible">
                            <label>Destination</label>
                            <input className="create-doc-set-loading-order-modal__input-text"
                                   type={"text"}
                                   name={'destination'}
                                   defaultValue={'destination'}
                                   onChange={formik.handleChange}
                                   onBlur={formik.handleBlur}
                            />
                            {formik.errors.destination && formik.touched.destination ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.destination}</p> : null}
                        </div>
                        <div className="create-doc-set-loading-order-modal__three-inputs-item create-doc-set-loading-order-modal__input-text-visible">
                            <label>Method of cleaning lines</label>
                            <input className="create-doc-set-loading-order-modal__input-text"
                                   type={"text"}
                                   name={'methodOfCleaningLines'}
                                   defaultValue={editDoc === true ? cargoCaseDocument[0]?.methodOfCleaningLines : formik.values.name}
                                   onChange={formik.handleChange}
                                   onBlur={formik.handleBlur}
                            />
                            {formik.errors.methodOfCleaningLines && formik.touched.methodOfCleaningLines ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.methodOfCleaningLines}</p> : null}
                        </div>
                    </div>
                    <div className="create-doc-set-loading-order-modal-buttons-block">
                        <div className="create-doc-set-loading-order-modal-buttons">
                            <button onClick={closeModal} className="create-doc-set-loading-order-modal-buttons__cancel">Cancel</button>
                            <button type={'submit'} className="create-doc-set-loading-order-modal-buttons__save">Save</button>
                        </div>
                    </div>
                </div>
            </form>
            {activeModalAddNewElementDictionary && <NoOptionsAddElementDictionaryModal
                onCloseModal={onCloseModal}
                onHandleConfirmAddElementDictionary={onHandleConfirmAddElementDictionary}
                isModalMessage={isModalMessage}
                isNoOptionMessageValue={isNoOptionMessageValue}
                setModalMessage={setModalMessage}
            />}
            {isNoOptionMessageEditValue !== '' &&
                <NoOptionsEditElementDictionary
                    onHandleConfirmEditElementDictionary={onHandleConfirmEditElementDictionary}
                    onCloseModal={onCloseModal}
                    isModalMessage={isModalMessage}
                />
            }
        </div>
    )
}
export default CreateDocSetLoadingOrderModal;